import { ReactElement, useState } from 'react'
import { Tooltip } from '../Tooltip'
import type { Contact } from 'app/types/entities'
import { getChannelColorMap } from 'lib/colorMappings'

export function ChannelCell({ channel }: { channel?: string }): ReactElement {
  const [message, setMessage] = useState<string | undefined>(undefined)
  return (
    <div className="inline-flex w-full items-center px-2 text-body-xs">
      <Tooltip
        message={message}
        className="truncate"
        onMouseOver={(event) => {
          if (
            event.currentTarget instanceof HTMLElement &&
            event.currentTarget.scrollWidth > event.currentTarget.clientWidth
          ) {
            setMessage(channel)
          } else setMessage(undefined)
        }}
      >
        <span
          className="mr-1.5 inline-block h-2 w-2 shrink-0 rounded-[2px] align-middle"
          style={{ backgroundColor: getChannelColorMap(channel as Contact[`channel`]) }}
        ></span>
        <span className="truncate text-body-xs">{channel}</span>
      </Tooltip>
    </div>
  )
}
